<template>
  <v-skeleton-loader type="image" transition="fade-transition" :loading="$apollo.queries.automatic_reply_message.loading">
    <v-card>
      <v-card-title class="pb-3">
        <span class="table-card-title px-0">Resposta automática</span>

        <v-tooltip right max-width="300px">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <mf-icon small class="ml-3 mb-1" color="cinza-0">info</mf-icon>
            </span>
          </template>
          <span
            >Neste campo deverá ser inserida a mensagem que o usuário já cadastrado receberá quando enviar qualquer mensagens para o Número de Disparo. Caso o
            consumidor envie várias mensagens ao número, ele receberá apenas uma resposta automática a cada 5 minutos.</span
          >
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="automatic_reply_message.active"
          :disabled="!editing"
          color="primary"
          hide-details
          single-line
          label="Ativo"
          class="pt-0 mt-0 pb-3"
        />
        <v-textarea
          v-model="automatic_reply_message.text"
          class="texto-corrido"
          :background-color="!editing ? 'cinza-l90' : null"
          :disabled="!editing"
          height="80px"
          outlined
          no-resize
          maxlength="500"
          counter="500"
        />

        <mf-action-buttons
          v-if="editing"
          :primary-button="{
            text: 'Salvar',
            action: () => save(),
            isVisible: true,
            isLoading: $wait.is('update-automatic-reply-message'),
          }"
          :cancel-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
          }"
        />

        <div v-else class="d-flex justify-end py-3">
          <mf-button label="Editar" @click="startEdit" />
        </div>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { QUERY_GET_MESSAGE_BY_TYPE, MUTATION_UPDATE_AUTOMATIC_REPLY_MESSAGE } from '@/modules/campanhas/whatsapp/graphql'
export default {
  data: () => ({
    backup_automatic_reply_message: '',
    automatic_reply_message: {},
    editing: false,
  }),
  apollo: {
    automatic_reply_message: {
      query: QUERY_GET_MESSAGE_BY_TYPE,
      variables: {
        type: 'AUTOMATIC_REPLY',
      },
      update({ getMessageByType }) {
        return getMessageByType
      },
    },
  },
  methods: {
    startEdit() {
      this.backup_automatic_reply_message = cloneDeep(this.automatic_reply_message)
      this.editing = true
    },
    endEdit() {
      this.editing = false
    },
    cancel() {
      this.automatic_reply_message = this.backup_automatic_reply_message
      this.endEdit()
    },
    async save() {
      try {
        this.$wait.start('update-automatic-reply-message')
        await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_AUTOMATIC_REPLY_MESSAGE,
          variables: {
            type: 'AUTOMATIC_REPLY',
            text: this.automatic_reply_message.text,
            active: this.automatic_reply_message.active || false,
          },
        })
        this.$snackbar({ message: 'Mensagem atualizada', snackbarColor: 'success' })
      } catch (error) {
        this.$snackbar({ message: 'Erro ao atualizar mensagem', snackbarColor: 'error' })
        this.cancel()
      } finally {
        this.$wait.end('update-automatic-reply-message')
        this.endEdit()
      }
    },
  },
}
</script>
